import React, { Suspense } from "react";
import Header from "./Header";
import SideDrawer from "./SideDrawer";
import "./NavigationLayout.scss";
import { useOnboardingCheck } from "./useOnboardingCheck";

const PrincipalAgentPermissionOnboardingModal = React.lazy(
  () =>
    import(
      "../../agencyProfile/PrincipalAgentPermissionOnboardingModal"
    ),
);

const NavigationLayout = ({ children }: { children: any }) => {
  const { showOnboarding, closeOnboarding, userRole } = useOnboardingCheck();
  return (
    <div className="navigation_layout_container">
      <Header />
      <SideDrawer />
      <div className="layout_container">{children}</div>

      {userRole === "agency" && showOnboarding && (
        <Suspense fallback={null}>
          <PrincipalAgentPermissionOnboardingModal
            open={showOnboarding}
            handleClose={closeOnboarding}
          />
        </Suspense>
      )}
    </div>
  );
};

export default NavigationLayout;
